import classNames from 'classnames';
import { intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';

export type CountdownTimerProps = {
    endTime?: Date;
    className?: string;
    variant?: 'daily' | 'game';
};

export type TimeLeft = {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
};

export const CountdownTimer = ({ endTime, className, variant = 'daily' }: CountdownTimerProps) => {
    const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeLeft());

    function getTimeLeft() {
        const now = new Date();
        const hasExpired = endTime ? now > endTime : false;
        if (hasExpired) return { days: '00', hours: '00', minutes: '00', seconds: '00' };

        const totalSeconds = Math.floor((endTime!.getTime() - now.getTime()) / 1000);
        const daysLeft = Math.floor(totalSeconds / 86400);
        const hoursLeft = Math.floor((totalSeconds - daysLeft * 86400) / 3600);
        const minutesLeft = Math.floor((totalSeconds - daysLeft * 86400 - hoursLeft * 3600) / 60);
        const secondsLeft = totalSeconds - daysLeft * 86400 - hoursLeft * 3600 - minutesLeft * 60;
        return {
            days: daysLeft.toString().padStart(2, '0'),
            hours: hoursLeft.toString().padStart(2, '0'),
            minutes: minutesLeft.toString().padStart(2, '0'),
            seconds: secondsLeft.toString().padStart(2, '0'),
        };
    }

    //Countdown for next quiz
    useEffect(() => {
        if (endTime) {
            const timerInterval = setInterval(() => {
                setTimeLeft(getTimeLeft());
            }, 1000);
            return () => {
                clearInterval(timerInterval);
            };
        }
    }, [endTime]);

    return variant === 'daily' ? (
        <span className={classNames(className)}>{`${
            +timeLeft.hours + +timeLeft.days * 24
        } : ${+timeLeft.minutes} : ${+timeLeft.seconds}`}</span>
    ) : (
        <div className="flex items-center justify-center space-x-2">
            <div className="flex flex-col items-center justify-center p-2 rounded-lg bg-white/5 backdrop-blur-md w-[72px]">
                <span className="text-white t__heading--h5">{timeLeft.days}</span>
                <span className="mt-1 capitalize t__overline--o1">Days</span>
            </div>
            <div className="flex flex-col items-center justify-center p-2 rounded-lg bg-white/5 backdrop-blur-md w-[72px]">
                <span className="text-white t__heading--h5">{timeLeft.hours}</span>
                <span className="mt-1 capitalize t__overline--o1">Hours</span>
            </div>
            <div className="flex flex-col items-center justify-center p-2 rounded-lg bg-white/5 backdrop-blur-md w-[72px]">
                <span className="text-white t__heading--h5">{timeLeft.minutes}</span>
                <span className="mt-1 capitalize t__overline--o1">Minutes</span>
            </div>
            <div className="flex flex-col items-center justify-center p-2 rounded-lg bg-white/5 backdrop-blur-md w-[72px]">
                <span className="text-white t__heading--h5">{timeLeft.seconds}</span>
                <span className="mt-1 capitalize t__overline--o1">Seconds</span>
            </div>
        </div>
    );
};
